import { render } from "./PlayoutEmptyPlaceholder.vue?vue&type=template&id=3ed25ac9"
import script from "./PlayoutEmptyPlaceholder.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayoutEmptyPlaceholder.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TVPlayout/PlayoutEmptyPlaceholder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ed25ac9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ed25ac9', __exports__)) {
    api.reload('3ed25ac9', __exports__)
  }
  
  module.hot.accept("./PlayoutEmptyPlaceholder.vue?vue&type=template&id=3ed25ac9", () => {
    api.rerender('3ed25ac9', render)
  })

}


export default __exports__